import React, { useEffect } from "react";

const GtagScript = () => {
  useEffect(() => {
    const script = document.createElement("script");
    const scriptText = document.createTextNode(
      '(function(){ window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag("js", new Date()); gtag("config", "G-8XNNSKLRRH"); gtag("config", "UA-115883754-1");})()'
    );
    script.id = "gtag-logic-script";
    script.appendChild(scriptText);
    document.body.appendChild(script);
  }, []);

  return <></>;
};

export default GtagScript;
